import { Chat as ChatType } from '@/app/lib/types'
import { useEffect, useState } from 'react'
import { Dispatch, SetStateAction } from 'react'

export function useChatUpdates(chatId: string | null) {
  const [chat, setChat] = useState<ChatType | null>(null)

  useEffect(() => {
    if (!chatId) return
    const eventSource = new EventSource(`/api/chat/stream?chatId=${chatId}`)

    eventSource.onmessage = event => {
      const update = JSON.parse(event.data)
      if (update.fullDocument) {
        if (update?.fullDocument?.isLiveChat) {
          setChat(update?.fullDocument)
        }
      }
    }

    return () => {
      eventSource.close()
    }
  }, [chatId])

  return [chat, setChat] as [
    ChatType | null,
    Dispatch<SetStateAction<ChatType | null>>
  ]
}
